import React, { useMemo } from 'react';
import Chart from 'react-apexcharts';
import { Box, Typography, Paper, Skeleton } from '@mui/material';
import { useSelector } from 'react-redux';

export default function IndividualPerfomanceChart({ sales }) {
  const individualMonthlyPerfomance = useSelector((state) => state.pointTracker.individualMonthlyPerfomance.data);
  const individualMonthlyPerfomanceLoading = useSelector(
    (state) => state.pointTracker.individualMonthlyPerfomance.loading,
  );

  const [series, categories] = useMemo(() => {
    let x1 = {
      name: sales ? 'Revenue' : 'TAR',
      data: [],
    };
    let x2 = {
      name: sales ? 'Sales' : 'SFR',
      data: [],
    };
    let categories = [];

    individualMonthlyPerfomance?.tableData?.forEach((value) => {
      x1.data.push(value?.[sales ? 'revenue' : 'tarValue']);
      x2.data.push(value?.[sales ? 'sales' : 'sfrValue']);
      categories.push(value?.month);
    });
    return [[x1, x2], categories];
  }, [individualMonthlyPerfomance, sales]);

  const options = useMemo(
    () => ({
      chart: {
        type: 'line',
        fontFamily: 'inherit',
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
      },
      colors: ['#3b82f6', '#a855f7'],
      stroke: {
        curve: 'smooth',
        width: 3,
      },
      markers: {
        size: 5,
        colors: ['#3b82f6', '#a855f7'],
        strokeColors: '#ffffff',
        strokeWidth: 2,
        hover: {
          size: 7,
        },
      },
      xaxis: {
        categories,
        axisBorder: {
          show: true,
          color: '#e2e8f0',
        },
        axisTicks: {
          show: true,
        },
        labels: {
          style: {
            colors: '#64748b',
            fontSize: '12px',
          },
        },
      },
      yaxis: {
        /* min: 0,
        max: 250, */
        tickAmount: 4,
        /* title: {
          style: {
            color: '#64748b',
            fontWeight: 500,
          },
        }, */
        labels: {
          style: {
            colors: '#64748b',
          },
        },
      },
      grid: {
        borderColor: '#e2e8f0',
        strokeDashArray: 4,
        xaxis: {
          lines: {
            show: true,
          },
        },
        yaxis: {
          lines: {
            show: true,
          },
        },
        padding: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 10,
        },
      },
      legend: {
        position: 'top',
        horizontalAlign: 'right',
        markers: {
          radius: 12,
        },
        itemMargin: {
          horizontal: 10,
          vertical: 0,
        },
      },
      tooltip: {
        shared: true,
        intersect: false,
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
          const month = categories[dataPointIndex];
          const tarValue = series[0][dataPointIndex];
          const sfrValue = series[1][dataPointIndex];

          return `
          <div style="padding: 10px; background: white; border: 1px solid #e2e8f0; border-radius: 8px; box-shadow: 0 4px 6px rgba(0,0,0,0.05);">
            <div style="font-weight: bold; margin-bottom: 8px; color: #1e293b;">${month}</div>
            <div style="color: #3b82f6; margin-bottom: 4px;">tar : ${tarValue}</div>
            <div style="color: #a855f7;">sfr : ${sfrValue}</div>
          </div>
        `;
        },
      },
    }),
    [categories],
  );

  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        borderRadius: 3,
        border: '1px solid #e2e8f0',
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
        width: '100%',
        // maxWidth: 900,
        bgcolor: 'white',
        overflowX: 'auto',
        overflowY: 'hidden',
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: -2 }}>
        <Typography variant="h6" sx={{ fontWeight: 700, color: '#1e293b' }}>
          {sales ? 'Sales & Revenue Trends' : 'Percentage Achievement (TAR vs SFR)'}
        </Typography>
      </Box>
      {individualMonthlyPerfomanceLoading ? (
        <Skeleton sx={{ width: '100%', minWidth: 400, height: '100%', minHeight: 200 }} />
      ) : (
        <Box
          component={Chart}
          options={options}
          series={series}
          type="line"
          sx={{
            width: '100%',
            minWidth: 500,
            height: '100%',
            minHeight: 300,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        />
      )}
    </Paper>
  );
}
